module.exports = __webpack_public_path__ + "static/img/send_kjdy.29c3fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/send_kjdy.png
// module id = 1262
// module chunks = 0